import React, { useState, useEffect } from "react";
import { useContent } from "contexts/contentContext/contentContext.js";
import parse from "html-react-parser";
import apiRequest from "utils/ApiRequest/apiRequest.js";
import usePageInit from "hooks/usePageInit.ts";

const Integration = ({ userData }) => {
  const { isPageReady } = usePageInit();
  const [exampleScript, setExampleScript] = useState(null);
  const { getTextByKey, getLanguageCulture, getPageText } = useContent();
  const [scriptOrIframe, setScriptOrIframe] = useState("script");
  useEffect(() => {
    getExampleScript("script");
  }, []);

  const getExampleScript = async (type) => {
    setScriptOrIframe(type);
    const parameters = {
      typeScript: type,
      culture: getLanguageCulture(),
      formId: 123456789,
      formWidth: 900,
      formHeight: 500,
      serviceType: "embedparams",
    };
    const response = await apiRequest(
      "EmbedDynamics",
      "CreateEmbedDynamicCodeReact",
      parameters
    );
    if (response.status === "success") {
      setExampleScript(response.data);
    }
  };

  if (!isPageReady) {
    return null;
  }

  return (
    <div className="integration-container">
      <div className="title">
        <h3>{getTextByKey("integration-title")}</h3>
      </div>
      <div className="main">
        <div className="content-page">
          <div className="sub-title">
            {" "}
            {parse(getTextByKey("embed-Integration-text1"))}
          </div>
          <div className="section-title">
            {parse(getTextByKey("embed-Integration-parameters-title"))}
          </div>
          <div className="integration-section">
            {parse(getTextByKey("embed-Integration-parameters-text"))}
          </div>
          <div className="section-integration-2">
            <div className="section-title">
              {parse(getTextByKey("embed-Integration-parameters-title2"))}
            </div>
            <div className="section-text">
              {parse(getTextByKey("embed-Integration-parameters-text2"))}
            </div>
          </div>
          <div className="integration-section">
            {parse(getTextByKey("embed-Integration-parameters-text3"))}
          </div>
          <div className="section-text please-note">
            <p>{parse(getTextByKey("embed-Integration-parameters-text4"))}</p>
          </div>
          <div className="section-text">
            <p>{parse(getTextByKey("embed-Integration-code-example-text"))}</p>
          </div>
        </div>
        <div className="form-script">
          <div className="get-links">
            <span
              onClick={() => {
                getExampleScript("script");
              }}
              className={scriptOrIframe === "script" ? "active" : ""}
            >
              Script
            </span>{" "}
            <span
              onClick={() => {
                getExampleScript("iframe");
              }}
              className={scriptOrIframe === "iframe" ? "active" : ""}
            >
              Iframe
            </span>
          </div>
          <div className="script-line">
            {exampleScript && (
              <div className="script-code">{parse(exampleScript)}</div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Integration;
//embed-Integration-text1
//embed-Integration-parameters-title
//embed-Integration-parameters-text
//embed-Integration-parameters-title2
//embed-Integration-parameters-text2
//embed-Integration-parameters-text3
//embed-Integration-parameters-text4
//embed-Integration-code-example-text
